export const environment = {
  production: false,
  existingCaseWorthyAPIURL:
  "https://step.caseworthy.net/CaseWorthy.API/",
nextGenAccountsAPIURL: "https://api.step.caseworthy.net/account/services/v1/",
nextGenFormsAPIURL: "https://api.step.caseworthy.net/forms/services/v1/",
nextGenQueryAPIURL: "https://api.step.caseworthy.net/query-apbuilder/services/v1/",
nextGenServerUrl: "https://api.step.caseworthy.net/",
};
